import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Link, Prompt, withRouter } from 'react-router-dom';
import { Badge, Button, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { EInput } from 'src/Components/EInput';
import PdfService from 'src/Services/Pdf';
import { ITest, IWellStory } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';




@inject('stores')
@observer
class RemarksB extends React.Component {
    public props: any;
    private test: ITest = new ITest();
    public TestsStore: any;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;

    public state = {
        additionalRecapSuggestion: false,
        isDirty: false,
        recapSuggestion: false,
        saveClicked: false,
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;

        this.handleInputChange = this.handleInputChange.bind(this);
        this.addMudReportRecap = this.addMudReportRecap.bind(this);
        this.addAdditional = this.addAdditional.bind(this);


        this.clearDisposers = this.clearDisposers.bind(this);
    }

    public componentDidMount() {
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            const test = toJS(this.props.stores.TestsStore.test);
            const additionalRecapSuggestion = test.remarks.additionalRecapSuggestion !== '';
            const recapSuggestion = test.remarks.recapSuggestion !== '';
            this.setState({
                additionalRecapSuggestion,
                recapSuggestion,
                test,
                well: toJS(this.props.stores.WellsStore.well)
            });
        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
        this.createDisposers();
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            const additionalRecapSuggestion = test.remarks.additionalRecapSuggestion !== '';
            const recapSuggestion = test.remarks.recapSuggestion !== '';
            this.setState({
                additionalRecapSuggestion,
                recapSuggestion,
                test
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private handleInputChange(event: any) {
        const test = this.state.test;
        test.remarks[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            test
        });
    }

    private addMudReportRecap() {
        const test = this.state.test;
        const wellStories = test.remarks.wellStories;
        const wellStory = new IWellStory();
        wellStory.remarkText = this.state.test.remarks.mudReportRecap;
        wellStory.remarkSubType = "Recap";
        wellStory.remarkSubmittedDate = moment().unix().toString();
        wellStories.unshift(wellStory);
        test.remarks.wellStories = wellStories;
        this.setState({
            isDirty: true,
            test
        });
    }

    private addAdditional() {
        const test = this.state.test;
        const wellStories = test.remarks.wellStories;
        const wellStory = new IWellStory();
        wellStory.remarkText = this.state.test.remarks.additional;
        wellStory.remarkSubType = "Additional";
        wellStory.remarkSubmittedDate = moment().unix().toString();
        wellStories.unshift(wellStory);
        test.remarks.wellStories = wellStories;
        this.setState({
            isDirty: true,
            test
        });
    }

    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private handleWellStoryDelete = (index: number) => (event: React.MouseEvent<HTMLDivElement>) => {
        const test = this.state.test;
        const wellStories = test.remarks.wellStories;
        wellStories.splice(index, 1);
        this.setState({
            isDirty: true,
            test
        });
    }

    private toggleSuggestion = (stateName: string) => () => {
        this.setState({
            [stateName]: !this.state[stateName]
        });
    }
    private buttonNavigation = (event: any) => {
        const $target = event.target;

        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/tourlytreatment');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/inventory/products');
        }
    }

    private recapTooLong() {
        return PdfService.isTooBigForRecap(this.state.test);
    }
    public render() {
        return(
            <div className="RemarksB">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md="5">
                        <h4>Well Story</h4>
                        <div className="well-story">
                            { this.state.test.remarks.wellStories &&
                                this.state.test.remarks.wellStories.map((story: IWellStory, index: number) =>
                                    <div key={index}>
                                        {story.remarkText.split('\n').map((remark, indexRem) => {
                                            if(remark === '') {
                                                return <br key={indexRem} />;
                                            }
                                            return <p key={indexRem} className="the-remark">{remark}</p>;
                                        })
                                        }
                                        <p className="remark-datetime">
                                            {story.remarkSubType + ' | ' + moment(story.remarkSubmittedDate, 'X').format('LLL')}
                                            {
                                                (story.createdWellTestId === '' || story.createdWellTestId === this.state.test.id)
                                                && this.state.test.testStatus !== 'Approved'
                                                &&
                                                <span onClick={this.handleWellStoryDelete(index)}>
                                                    {' | '}<FontAwesomeIcon icon={faTrashAlt} />
                                                </span>
                                            }
                                        </p>
                                    </div>
                            ) }
                        </div>
                        {
                            this.state.test.remarks.wellStories.length === 0 ?
                            <Button color="primary" disabled={true}>Print Well Story</Button>
                            :
                            <Link className='btn btn-primary' to={`/print/well/${this.state.well.id}/test/${this.state.test.id}/wellstorypdf`} target="_blank">Print Well Story</Link>
                        }
                        <Form>
                            <h4>Private: Internal Remarks</h4>
                            <FormGroup>
                                <Label>Private Remarks</Label>
                                <EInput
                                    type="textarea"
                                    rows="6"
                                    name="internal"
                                    id="internal"
                                    value={this.state.test.remarks.internal}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col md="7">
                        <Form>
                            <h4>Mud Report/Recap Remarks</h4>
                            <FormGroup className="required">
                                <Label>Mud Report/Recap Remarks</Label>
                                <EInput
                                    type="textarea"
                                    rows="6"
                                    name="mudReportRecap"
                                    id="mudReportRecap"
                                    required={true}
                                    value={this.state.test.remarks.mudReportRecap}
                                    onChange={this.handleInputChange}
                                />

                                { this.recapTooLong() && <h5 style={{marginBottom: 0}}><Badge color="danger">Not all remarks will display on the Mud Report</Badge></h5>}
                            </FormGroup>
                            {
                                this.state.recapSuggestion &&
                                <FormGroup>
                                    <Label>Recap Suggestion</Label>
                                    <EInput
                                        type="textarea"
                                        rows="6"
                                        name="recapSuggestion"
                                        id="recapSuggestion"
                                        value={this.state.test.remarks.recapSuggestion}
                                        onChange={this.handleInputChange}
                                    />
                                </FormGroup>
                            }
                            <FormGroup style={{marginBottom: '10px'}}>
                                <Button color="primary" onClick={this.addMudReportRecap} disabled={this.state.test.remarks.mudReportRecap === '' ? true : false}>Add to Well Story</Button>
                                <Button color="primary" disabled={this.state.test.remarks.recapSuggestion !== ''} onClick={this.toggleSuggestion('recapSuggestion')}>Add Recap Suggestions</Button>
                            </FormGroup>
                            <FormGroup>
                                <Label>Additional Recap Remarks</Label>
                                <EInput
                                    type="textarea"
                                    rows="6"
                                    name="additional"
                                    id="additional"
                                    value={this.state.test.remarks.additional}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                            {
                                this.state.additionalRecapSuggestion &&
                                <FormGroup>
                                    <Label>Additional Recap Suggestion</Label>
                                    <EInput
                                        type="textarea"
                                        rows="6"
                                        name="additionalRecapSuggestion"
                                        id="additionalRecapSuggestion"
                                        value={this.state.test.remarks.additionalRecapSuggestion}
                                        onChange={this.handleInputChange}
                                    />
                                </FormGroup>
                            }
                            <FormGroup style={{marginBottom: '10px'}}>
                                <Button color="primary" onClick={this.addAdditional} disabled={this.state.test.remarks.additional === '' ? true : false}>Add to Well Story</Button>
                                <Button color="primary" disabled={this.state.test.remarks.additionalRecapSuggestion !== ''} onClick={this.toggleSuggestion('additionalRecapSuggestion')}>Add Additional Recap Suggestions</Button>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
            </div>
        );
    }
}

export default withRouter(RemarksB);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/FluidData/RemarksB/RemarksB.tsx